import { render, staticRenderFns } from "./Batches.vue?vue&type=template&id=98dc75ba&scoped=true"
import script from "./Batches.vue?vue&type=script&lang=js"
export * from "./Batches.vue?vue&type=script&lang=js"
import style0 from "./Batches.vue?vue&type=style&index=0&id=98dc75ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dc75ba",
  null
  
)

export default component.exports